module.exports = "/_next/static/images/back-c499828504b84e8f5396e5e37b340951.svg";